import React, { useEffect, useReducer, createContext, useContext } from "react";
import clientConfig from "client_proxy";
import { restClient } from "transport-layer";

const {
  CLIENT_NAME,
  // CLIENT_NAME: CLIENT_NAME_LABEL,
  CLIENT_NAME_LABEL,
  CLIENT_THEME,
  CLIENT_CUSTOM_ROUTES,
  USER_ROLES,
  DEPLOY_TARGET_TABS,
  CUSTOM_RESOURCES,
  EXTRA_MENUS,
  CLIENT_LOGO,
  APP_BAR_LOGO,
  BACKGROUND_IMAGE,
  AUTH_SUPPLIER_SOURCES,
  featureList,
  CUSTOM_PAGES,
  DASHBOARD_CONFIG,
  REPORTING_OPTIONS,
  routeOverrides
} = clientConfig;

const initialState = {
  dataThruByWarehouse: [],
  client: {
    CLIENT: CLIENT_NAME,
    CLIENT_NAME: CLIENT_NAME,
    name: CLIENT_NAME,
    resourcePrefix: CLIENT_NAME,
    nameLabel: CLIENT_NAME_LABEL,
    logo: CLIENT_LOGO,
    menus: EXTRA_MENUS,
    theme: CLIENT_THEME,
    appBarLogo: APP_BAR_LOGO,
    backgroundImage: BACKGROUND_IMAGE,
    authorizedSupplierSources: AUTH_SUPPLIER_SOURCES,
    customPages: CUSTOM_PAGES,
    CUSTOM_PAGES: CUSTOM_PAGES,
    featureList: featureList,
    availableRoles: USER_ROLES,
    customRoutes: CLIENT_CUSTOM_ROUTES,
    CUSTOM_RESOURCES: CUSTOM_RESOURCES,
    dashboardData: {
      aggPeriod: "4WK",
      showAggPeriodSelector: false,
      deployTargetTabOptions: DEPLOY_TARGET_TABS,
      sunburstHierarchies: DASHBOARD_CONFIG["sunburstHierarchies"],
    },
    reportingOptions: {
      ...REPORTING_OPTIONS
    },
    routeOverrides: routeOverrides
  },
  loading: false,
  error: null,
};

export const ClientContext = createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case "IB/FEATURE_FLAG_SET":
      return {
        ...state,
        loading: false,
        error: null,
      };
    // case "IB/FEATURE_FLAG_UPDATE":
    //   return {
    //     ...state,
    //     ...action.payload,
    //   };
    case "SET_RUNTIME_ITEM_GROUP_COLUMN_OPTIONS":
      return {
        ...state,
        client: {
          ...state.client,
          reportingOptions: {
            ...state.client.reportingOptions,
            itemGroupColumnOptions: action.payload,
          },
        },
      };
    case "SET_STORE_ATTR_OPTIONS":
      return {
        ...state,
        client: {
          ...state.client,
          reportingOptions: {
            ...state.client.reportingOptions,
            storeAttrOptions: action.payload,
          },
        },
      };
    case "STORE_GROUP_BY_OPTIONS":
      return {
        ...state,
        client: {
          ...state.client,
          reportingOptions: {
            ...state.client.reportingOptions,
            storeGroupByOptions: action.payload,
          },
        },
      };
    case "ITEM_ATTR_OPTIONS":
      return {
        ...state,
        client: {
          ...state.client,
          reportingOptions: {
            ...state.client.reportingOptions,
            itemAttrOptions: action.payload,
          },
        },
      };
    case "STORE_FILTER_OPTIONS":
      return {
        ...state,
        client: {
          ...state.client,
          reportingOptions: {
            ...state.client.reportingOptions,
            storeFilterOptions: action.payload.map(d => ({...d, reference: `${CLIENT_NAME}_${d.reference}`})),
          },
        },
      };
      case "ITEM_FILTER_OPTIONS":
        return {
          ...state,
          client: {
            ...state.client,
            reportingOptions: {
              ...state.client.reportingOptions,
              runtimeItemGroupFilterOptions: action.payload.map(d => ({...d, reference: `${CLIENT_NAME}_${d.name}`})),
            },
          },
        };
      case "UPDATE_DATA_THRU_DATES_BY_WAREHOUSE":
        
        return {
          ...state,
          client: {
            ...state.client,
            dataThruByWarehouse: action.payload,
          }
        };
    default:
      throw new Error();
  }
};

export const ClientContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);


  useEffect(() => {
    if (localStorage.getItem('token')) {
      getReportingOptions();
    }
   
  }, []);

  const refreshContext = () => {
    if (localStorage.getItem('token')) {
      getReportingOptions();
    }
  };

  async function getReportingOptions() {
    try {
      const client = process.env.REACT_APP_CLIENT; // get client from state, probably with useContext

      // const itemFilterOptions = await getReportOptions(
      //   client,
      //   "master_item_report_filter_definitions"
      // );
      

      // const itemGroupColumnOptions = await getReportOptions(
      //   client,
      //   "master_item_report_runtime_item_group_column_options"
      // );

      // const storeAttrOptions = await getReportOptions(
      //   client,
      //   "master_store_report_attribute_options"
      // );

      // const storeGroupByOptions = await getReportOptions(
      //   client,
      //   "master_store_report_group_by_options"
      // );

      // const itemAttrOptions = await getReportOptions(
      //   client,
      //   "master_item_report_attribute_options"
      // );

      // const storeFilterOptions = await getReportOptions(
      //   client,
      //   "master_store_report_filter_definitions"
      // );

      const getDataThruByWarehouse = await restClient.getList(`${client}_data_thru`, {
        sort: { order: "desc", field: "max_thru_date" },
        pagination: { page: 1, perPage: 380 },
        filter: {},
      })
      
      dispatch({
        type: "UPDATE_DATA_THRU_DATES_BY_WAREHOUSE",
        payload: getDataThruByWarehouse.data,
      });

      // dispatch({
      //   type: "SET_RUNTIME_ITEM_GROUP_COLUMN_OPTIONS",
      //   payload: itemGroupColumnOptions.data,
      // });

      // dispatch({
      //   type: "SET_STORE_ATTR_OPTIONS",
      //   payload: storeAttrOptions.data,
      // });

      // dispatch({
      //   type: "STORE_GROUP_BY_OPTIONS",
      //   payload: storeGroupByOptions.data,
      // });

      // dispatch({
      //   type: "ITEM_ATTR_OPTIONS",
      //   payload: itemAttrOptions.data,
      // });
      // dispatch({
      //   type: "STORE_FILTER_OPTIONS",
      //   payload: storeFilterOptions.data,
      // });
      // dispatch({
      //   type: "ITEM_FILTER_OPTIONS",
      //   payload: itemFilterOptions.data,
      // });



    } catch (e) {
      console.error(e);
    }
  }
  return (
    <ClientContext.Provider value={{state, refreshContext}}>
      {props.children}
    </ClientContext.Provider>
  );
};

export const useClientContext = () => {
  // get the context
  const context = useContext(ClientContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error("useClientContext was used outside of its Provider");
  }

  // return the context and the refresh function
  return {
    ...context,
    refreshContext: context.refreshContext,
  };
};


// async function getReportOptions(client, table) {
  
//   try {
//     const response = await restClient.getList(`${client}_${table}`, {
//       sort: { order: "asc", field: "name" },
//       range: { start: 0, end: 500 },
//       filter: {},
//       pagination: { page: 1, perPage: 5000 },
//     });
//     return response;
//   } catch (error) {
//     const { status } = error;
//     switch (status) {
//       case 401:
//         // window.location.href = '#/login'
//         throw new Error("Permission Denied, please log in");
//       default:
//         throw new Error(error);
//     }
//   }
// }